import React from "react";
import { Video } from "lucide-react";
import { useChampionApply } from "@/hooks/useChampionApply";
import { LearnGrid, ChampionTestimonials, CommunityHubBanner } from "@/components/oc/ChampionSections";
import { PriceNote, TrialLocked, ChampionConfirmed, ChampionApplyForm } from "@/components/oc/ChampionApply";
import { ChampionStatus } from "@/components/oc/ChampionStatus";

export { OC_DATES, upcomingDates } from "@/components/oc/dates";

function ApplyPanel() {
  const { nav, info, form, setForm, loading, confirmed, setConfirmed, included, apply } = useChampionApply();
  const trial = !!info?.trial;
  return (
    <section className="max-w-3xl mx-auto px-5 md:px-8 py-16">
      <div className="bg-cream-card border border-cream-deep rounded-3xl p-8 md:p-10">
        <div className="flex items-center gap-3 mb-2"><Video className="h-6 w-6 text-coral" /><h2 className="text-2xl font-bold text-brand">Apply for the next cohort</h2></div>
        <p className="text-muted-foreground mb-6">Nominate your member of staff and choose an upcoming live date.</p>
        <ChampionStatus applications={info?.applications} />
        {trial && <TrialLocked onSubscribe={() => nav("/app/billing")} />}
        {!trial && <PriceNote included={included} />}
        {!trial && confirmed && <ChampionConfirmed confirmed={confirmed} onReset={() => setConfirmed(null)} />}
        {!trial && !confirmed && <ChampionApplyForm form={form} setForm={setForm} included={included} loading={loading} onSubmit={apply} />}
      </div>
    </section>
  );
}

export default function OralChampionSection({ showTestimonials = true }) {
  return (
    <>
      <LearnGrid />
      {showTestimonials && <ChampionTestimonials />}
      <ApplyPanel />
      <CommunityHubBanner />
    </>
  );
}
